import React from 'react'
import { Validator } from "./../../../utils/web_config";
import Format from "date-fns/format";
import { Tooltip } from "@material-ui/core";

const ticketsNumber = {
  series: [
    {
      name: "Tickets sold",
      data: [37, 43, 38, 49, 61],
    },
  ],
  options: {
    chart: {
      toolbar: {
        show: false,
      },
    },
    grid: {
      show: false,
      padding: {
        left: 0,
        right: 0,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    legend: {
      show: false,
    },
    labels: ["07:00", "10:00", "12:00", "14:00", "16:00"],

    yaxis: {
      opposite: true,
      labels: {
        show: false,
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
    },
  },
};
///////////////

const channelPerform = (t, data) => {
  var config = {
    series: data?.data?.series == null ? [] : data?.data?.series,

    options: {
      theme: { mode: t },
      labels: data?.data?.labels == null ? [] : data?.data?.labels,
      dataLabels: {
        enabled: false,
      },
      legend: {
        position: "right",
      },
      noData: {
        text: data.status=='loading'?"Loading data...":data.status=='error'?'Error loading data,try to refresh':"No data yet",
        align: "center",
        verticalAlign: "middle",
        offsetX: 0,
        offsetY: 0,
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        theme: true,
        y: {
          formatter: function (
            value,
            { series, seriesIndex, dataPointIndex, w }
          ) {
            return new Validator().formatMoney(value);
          },
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                showAlways: true,
                show: true,
                formatter: function (v) {
                  var tot = v.globals.seriesTotals.reduce((a, b) => {
                    return a + b;
                  }, 0);
                  return new Validator().formatNumber(tot);
                },
              },
              value: {
                showAlways: true,
                show: true,
              },
              name: {
                show: false,
              },
            },
          },
        },
      },
    },
  };

  return config;
};

///////////////

const routePerform = (t, data) => {
  var config = {
    series: [
      {
        name: "Revenue",
        data: data?.data?.series == null ? [] : data?.data?.series,
      },
    ],
    options: {
      theme: { mode: t },
      noData: {
        text: data.status=='loading'?"Loading data...":data.status=='error'?'Error loading data,try to refresh':"No data yet",
        align: "center",
        verticalAlign: "middle",
        offsetX: 0,
        offsetY: 0,
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        theme: true,
        y: {
          formatter: function (
            value,
            { series, seriesIndex, dataPointIndex, w }
          ) {
            return new Validator().formatMoney(value);
          },
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
      },
      plotOptions: {
        bar: {
          
          distributed: false,
          startingShape: "flat",
          barHeight: "30%",
          endingShape: "rounded",
          dataLabels: {
            position: "top",
          },
        },
      },
      chart: {
        toolbar: {
          show: false,
        },
      },
      legend: {
        show: false,
      },
      grid: {
        show: true,
        padding: {
          left: 0,
          right: 0,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },

      labels: data?.data?.labels == null ? [] : data?.data?.labels,

      yaxis: {
        labels: {
          show: true,
        },
      },
      xaxis: {
        labels: {
          show: true,
        },
      },
    },
  };

  return config;
};

///////////////

const operatorPerform = (t, data) => {
  var config = {
    series: data?.data?.series == null ? [] : data?.data?.series,

    options: {
      theme: { mode: t },
      labels: data?.data?.labels == null ? [] : data?.data?.labels,
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
        position: "right",
      },
      noData: {
        text: data.status=='loading'?"Loading data...":data.status=='error'?'Error loading data,try to refresh':data.status=='loading'?"Loading data...":data.status=='error'?'Error loading data,try to refresh':"No data yet",
        align: "center",
        verticalAlign: "middle",
        offsetX: 0,
        offsetY: 0,
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        theme: true,
        y: {
          formatter: function (
            value,
            { series, seriesIndex, dataPointIndex, w }
          ) {
            return new Validator().formatMoney(value);
          },
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                showAlways: true,
                show: true,
                formatter: function (v) {
                  var tot = v.globals.seriesTotals.reduce((a, b) => {
                    return a + b;
                  }, 0);
                  return new Validator().formatNumber(tot);
                },
              },
              value: {
                showAlways: true,
                show: true,
              },
              name: {
                show: false,
              },
            },
          },
        },
      },
    },
  };

  return config;
};
///////////////

const revenueSplit = {
  series: [
   
  ],
  options: {
    noData: {
      text: "No data yet",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        startingShape: "flat",
        endingShape: "rounded",
        columnWidth: "30%",
        barHeight: "70%",
        distributed: false,

        dataLabels: {
          position: "top",
        },
      },
    },
    chart: {
      toolbar: {
        show: false,
      },
    },
    legend: {
      show: true,
      position: "top",
    },
    grid: {
      show: true,
      padding: {
        left: 0,
        right: 0,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },

    labels: [],

    yaxis: {
      labels: {
        show: true,
      },
    },
    xaxis: {
      labels: {
        show: true,
      },
    },
  },
};

///////////////

const channelWallets = {
  series: [0, 0, 0],
  options: {
    labels: ["Card", "App", "Web"],
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "right",
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
            },
            value: {
              showAlways: true,
              show: true,
              formatter: function (v) {
                return v;
              },
            },
            name: {
              show: false,
            },
          },
        },
      },
    },
  },
};

///////////////

const channelTransactions = {
  series: [12334, 2347, 122, 48, 234],
  options: {
    labels: ["POS", "Card", "App", "Web", "KeyKiosk"],
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "right",
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
            },
            value: {
              showAlways: true,
              show: true,
              formatter: function (v) {
                return v;
              },
            },
            name: {
              show: false,
            },
          },
        },
      },
    },
  },
};

///////////////

const channelFinancial = {
  series: [567, 239, 399, 129],
  options: {
    labels: ["Card", "App", "Web", "KeyKiosk"],
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "right",
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
            },
            value: {
              showAlways: true,
              show: true,
              formatter: function (v) {
                return v;
              },
            },
            name: {
              show: false,
            },
          },
        },
      },
    },
  },
};

/////////////////////////

const agentTransactions = (t, data) => {
  var config = {
    series: [
      {
        name: "Transactions",
        data: data?.data?.series == null ? [] : data?.data?.series,
      },
    ],
    options: {
      noData: {
        text: data.status=='loading'?"Loading data...":data.status=='error'?'Error loading data,try to refresh':"No data yet",
        align: "center",
        verticalAlign: "middle",
        offsetX: 0,
        offsetY: 0,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          startingShape: "flat",
          endingShape: "rounded",
          columnWidth: "30%",
          barHeight: "70%",
          distributed: false,

          dataLabels: {
            position: "top",
          },
        },
      },
      chart: {
        toolbar: {
          show: false,
        },
      },
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },

      labels: data?.data?.labels == null ? [] : data?.data?.labels,

      yaxis: {
        labels: {
          show: true,
        },
      },
      xaxis: {
        labels: {
          show: true,
          formatter: function (value, timestamp, opts) {
            var v = value == undefined ? new Date() : value;
            var d = Date.parse(v);

            return Format(new Date(d), ["EE"]);
          },
        },
      },
    },
  };
  return config;
};

///////////////


const agentsPerformance = (t, data) => {
  var config = {
    series: [
      {
        name: "Amount",
        data: data?.data?.series2 == null ? [] : data?.data?.series2,
      },
    ],
    options: {
      noData: {
        text: data.status=='loading'?"Loading data...":data.status=='error'?'Error loading data,try to refresh':"No data yet",
        align: "center",
        verticalAlign: "middle",
        offsetX: 0,
        offsetY: 0,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          startingShape: "flat",
          endingShape: "rounded",
          columnWidth: "30%",
          barHeight: "70%",
          distributed: false,

          dataLabels: {
            position: "top",
          },
        },
      },
      chart: {
        toolbar: {
          show: false,
        },
      },
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },

      labels: data?.data?.labels == null ? [] : data?.data?.labels,

      yaxis: {
        labels: {
          show: true,
        },
      },
      xaxis: {
        labels: {
          show: true,
          formatter: function (value, timestamp, opts) {
            var v = value == undefined ? new Date() : value;
            var d = Date.parse(v);

            return Format(new Date(d), ["EE"]);
          },
        },
      },
    },
  };
  return config;
};
///////////////

/////////////////////////

const financialTransactions = {
  series: [
  
  ],
  options: {
    noData: {
      text: 'No data yet',
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
    },
    chart: {
      toolbar: {
        show: false,
      },
    },
    legend: {
      show: true,
      position: "top",
      floating: true,
    },
    grid: {
      show: true,
      padding: {
        left: 0,
        right: 0,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      show: true,
    },
    stroke: {
      curve: "smooth",
    },

    yaxis: {
      labels: {
        show: true,
      },
    },
    xaxis: {
      labels: {
        show: true,
      },
    },
  },
};
///////////////
/////////////////////////

const inventorySales = {
  series: [
    // {
    //   name: "POS",
    //   data: [
    //     Math.floor(Math.random() * 299),
    //     Math.floor(Math.random() * 299),
    //     Math.floor(Math.random() * 299),
    //     Math.floor(Math.random() * 299),
    //     Math.floor(Math.random() * 299),
    //     Math.floor(Math.random() * 299),
    //     Math.floor(Math.random() * 299),
    //     Math.floor(Math.random() * 299),
    //     Math.floor(Math.random() * 299),
    //     Math.floor(Math.random() * 299),
    //     Math.floor(Math.random() * 299),
    //     Math.floor(Math.random() * 299),
    //   ],
    // },
    // {
    //   name: "Cards",
    //   data: [
    //     Math.floor(Math.random() * 2999),
    //     Math.floor(Math.random() * 2999),
    //     Math.floor(Math.random() * 2999),
    //     Math.floor(Math.random() * 2999),
    //     Math.floor(Math.random() * 2999),
    //     Math.floor(Math.random() * 2999),
    //     Math.floor(Math.random() * 2999),
    //     Math.floor(Math.random() * 2999),
    //     Math.floor(Math.random() * 2999),
    //     Math.floor(Math.random() * 2999),
    //     Math.floor(Math.random() * 2999),
    //     Math.floor(Math.random() * 2999),
    //   ],
    // },
    // {
    //   name: "Validators",
    //   data: [
    //     Math.floor(Math.random() * 59),
    //     Math.floor(Math.random() * 39),
    //     Math.floor(Math.random() * 99),
    //     Math.floor(Math.random() * 99),
    //     Math.floor(Math.random() * 99),
    //     Math.floor(Math.random() * 99),
    //     Math.floor(Math.random() * 99),
    //     Math.floor(Math.random() * 99),
    //     Math.floor(Math.random() * 99),
    //     Math.floor(Math.random() * 99),
    //     Math.floor(Math.random() * 99),
    //     Math.floor(Math.random() * 99),
    //   ],
    // },
  ],
  options: {
    noData: {
      text: "No data yet",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
    },
    chart: {
      toolbar: {
        show: false,
      },
    },
    legend: {
      show: true,
      position: "top",
      floating: true,
    },
    grid: {
      show: true,
      padding: {
        left: 0,
        right: 0,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      show: true,
    },
    stroke: {
      curve: "smooth",
    },

    labels: [
  
    ],

    yaxis: {
      labels: {
        show: true,
      },
    },
    xaxis: {
      labels: {
        show: true,
      },
    },
  },
};

///////////////

const agentsData = {
  filterType: "dropdown",
  responsive: "stacked",
  selectableRows: "single",
  searchPlaceholder: "Search agent...",
  selectableRowsOnClick: true,
  fixedHeader: true,
  searchProps: {
    variant: "outlined",
    margin: "dense",
  },
};

export {
  ticketsNumber,
  channelPerform,
  routePerform,
  operatorPerform,
  agentTransactions,
  agentsPerformance,
  agentsData,
  revenueSplit,
  channelFinancial,
  channelWallets,
  channelTransactions,
  financialTransactions,
  inventorySales,
};
